import React, { Component } from 'react';
import { getUsersByPromoCode } from '../services/userservice';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, Box } from '@mui/material';

const containerSx = {
  maxWidth: '960px',
  margin: '40px auto',
  padding: '40px 20px',
  backgroundColor: 'rgba(0, 0, 0, 0.45)',
  borderRadius: '20px',
  boxShadow: '0 0 50px rgba(0,0,0,0.3)',
  backdropFilter: 'blur(4px)',
  marginBottom: '40px',
};

const tableHeaderSx = {
  fontWeight: 600,
  color: 'white',
  fontSize: '14px',
};

const tableCellSx = {
  color: 'white',
  fontSize: '13px',
};

const titleSx = {
  color: 'white',
  fontWeight: 600,
  fontSize: '24px',
  marginBottom: '20px',
};

const errorSx = {
  color: 'red',
  marginBottom: '20px',
};

class PromoUsersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliatedUsers: [],
      error: null,
      fadeIn: false,
    };
  }

  async componentDidMount() {
    const promoCode = this.props.promoCode;

    const accessToken = this.props.accessToken;

    try {
      const affiliatedUsers = await getUsersByPromoCode(promoCode, accessToken);
      this.setState({ affiliatedUsers }, () => {
        setTimeout(() => this.setState({ fadeIn: true }), 30);
      });
    } catch (error) {
      this.setState({ error: 'Failed to fetch users' });
    }
  }

  renderTable(title, users) {
    return (
      <Box sx={containerSx}>
        <Typography sx={titleSx}>{title}</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={tableHeaderSx}>Name</TableCell>
              <TableCell sx={tableHeaderSx}>Phone Number</TableCell>
              <TableCell sx={tableHeaderSx}>Email</TableCell>
              <TableCell sx={tableHeaderSx}>Free Trial</TableCell>
              <TableCell sx={tableHeaderSx}>Start Date</TableCell>
              <TableCell sx={tableHeaderSx}>End Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user, idx) => (
              <TableRow key={idx}>
                <TableCell sx={tableCellSx}>{user.name}</TableCell>
                <TableCell sx={tableCellSx}>{user.phoneNumber}</TableCell>
                <TableCell sx={tableCellSx}>{user.email}</TableCell>
                <TableCell sx={tableCellSx}>{user.isFreeTrial ? 'Yes' : 'No'}</TableCell>
                <TableCell sx={tableCellSx}>{user.startDate}</TableCell>
                <TableCell sx={tableCellSx}>{user.endDate}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    );
  }

  render() {
    const { affiliatedUsers, error, fadeIn } = this.state;

    const freeTrialUsers = affiliatedUsers.filter(user => user.isFreeTrial);
    const paidUsers = affiliatedUsers.filter(user => !user.isFreeTrial);

    return (
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
          paddingTop: '100px',
          paddingBottom: '60px',
          opacity: fadeIn ? 1 : 0,
          transition: 'opacity 1s ease-in',
        }}
      >
        {error && <Typography sx={errorSx}>{error}</Typography>}
        {this.renderTable('Free Trial Users', freeTrialUsers)}
        {this.renderTable('Paid Users', paidUsers)}
      </Box>
    );
  }
}

export default PromoUsersTable;